const EVENT = 'leaply:tab-retap'

// A tap on the tab already showing its root: "go back to its start".
export function emitTabRetap(path: string) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: path }))
}

export function onTabRetap(path: string, handler: () => void): () => void {
  const listener = (event: Event) => {
    if ((event as CustomEvent<string>).detail === path) handler()
  }
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
